import { supabase } from '../../../services/supabase';
import { SummaryCheckinProps } from '../types/types';

export const getCheckins = async (
  startTime: string,
  endTime: string,
  userId: string | undefined,
): Promise<SummaryCheckinProps[] | undefined> => {
  const { data, error } = await supabase
    .from('check_ins')
    .select('id, check_in_time')
    .eq('user_id', userId)
    .gte('check_in_time', `${startTime}`)
    .lte('check_in_time', `${endTime}`);
  if (error) {
    console.error('error fetching checkins', error);
    return undefined;
  }
  return data || undefined;
};
// export const getLastWorkingDay = async (
//   employeeId: string | null | undefined,
// ): Promise<string | undefined> => {
//   if (!employeeId) return undefined;
//   let previousDay = new Date().toISOString().split('T')[0];
//   while (!isWeekend(previousDay)) {
//     [previousDay] = new Date(new Date(previousDay).getTime() - 86400000)
//       .toISOString()
//       .split('T');
//   }
//   // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
//   const { data, error } = await hrmsSupabase
//     .from('leaves')
//     .select('*')
//     .eq('employee_id', employeeId)
//     .lte('start_date', `${previousDay}T00:00:00`)
//     .gte('end_date', `${previousDay}T00:00:00`)
//     .maybeSingle();
//   if (error) {
//     console.error('error fetching OOO data');
//     return undefined;
//   }
//   if (!data) return previousDay;
//   return undefined;
// };

export const getMeetings = async (
  startTime: string,
  endTime: string,
  userId: string | undefined,
): Promise<string[] | undefined> => {
  const { data, error } = await supabase
    .from('calendar_events')
    .select('*')
    .eq('user_id', userId)
    .gte('start_time', startTime)
    .lte('end_time', endTime)
    .lt('duration', '24:00:00');
  if (error) {
    console.error('error fetching meetings', error);
    return undefined;
  }
  return data?.map((item: { title: string }) => item?.title || '');
};
